<canvas #canvasDocument class="canvas"></canvas>
<footer class="footer">
  <div class="footer__fps">{{ fps }}</div>
  <div class="footer__button-group">
    <p class="footer__label">Camera tool type:</p>
    <button
      class="footer__button"
      *ngFor="let cameraToolType of cameraToolTypesMap.keys()"
      (tap)="selectCameraTool(cameraToolType)"
      [class.is-active]="selectedCameraToolType === cameraToolType"
    >
      {{ cameraToolTypesMap.get(cameraToolType) }}
    </button>
  </div>
</footer>
